module.exports = __webpack_public_path__ + "static/media/my_sinisters.0a3f40ac.svg";